import React, { useEffect, useState } from "react";
import { getAllProducts } from "../../../../api/action/products";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router';
import { academyLogger } from "utils/logger";

const ServiceProducts = () => {
  const [productList, setProductList] = useState([]);
  const [currencySymbol, setCurrencySymbol] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const companyDetail = useSelector((state) => state.companyReducer.company);
  const companyPrimayId = companyDetail.primaryId;

  useEffect(() => {
    const companyData = companyDetail;
    const operatingLocation = companyData?.operatingLocation?.code;

    if (operatingLocation === "IND") {
      setCurrencySymbol("₹"); // Indian Rupee symbol
    } else if (operatingLocation === "US") {
      setCurrencySymbol("$"); // US Dollar symbol
    }
  }, [companyDetail]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await getAllProducts(companyPrimayId)(dispatch);
        academyLogger.info("Fetched Products:", response);
        setProductList(response);
      } catch (error) {
        academyLogger.error("Error fetching products:", error);
      }
    };

    if (companyPrimayId) {
      fetchProducts();
    }
  }, [companyPrimayId, dispatch]);

  const handleView = (product) => {
    navigate('/service-info', { state: { primaryId: product.primaryId, product } });
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center">
      {/* Header Section */}
      <div className="text-center mb-6">
        <h2 className="text-3xl font-semibold text-gray-600">Our Services</h2>
        <p className="mt-2 text-lg text-gray-600">
          Explore our wide range of services tailored to meet your needs.
        </p>
      </div>

      {/* Product Grid Section */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-6 items-start justify-center">
        {productList.map((product) => (
          <div
            key={product.id}
            className="col-span-1 rounded-md border transform transition duration-500 hover:scale-105 hover:shadow-2xl"
            style={{ minWidth: "250px", maxWidth: "300px", height: "100%" }}
          >
            <div className="flex flex-col h-full">
              <img
                loading="lazy"
                src={product.imageUrlsList?.[0] || "default-image-url.jpg"} // Use the first image URL or a default fallback
                alt={product.name || "Service"}
                className="aspect-[16/9] w-full bg-gray-800 rounded-md md:aspect-auto md:h-[300px] lg:h-[200px] scale-75 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-100 duration-300"
              />
              <div className="p-4 flex flex-col justify-between flex-grow">
                <div>
                  <h1 className="inline-flex items-center text-lg font-semibold text-gray-800 hover:text-orange-400 text-pretty cursor-pointer">
                    {product.name}
                  </h1>
                  <p
                    className="mt-3 text-sm text-gray-600 truncate"
                    title={product.description}
                  >
                    {product.description.length > 50
                      ? `${product.description.substring(0, 50)}...`
                      : product.description}
                  </p>
                </div>
                <div className="mt-2">
                  <span className="mb-2 mr-2 inline-block px-3 text-2xl font-medium p-2 rounded-xl">
                    {currencySymbol} {product.price.priceAmt}
                  </span>
                </div>
                <button
                  type="button"
                  id="view-schedule-button"
                  onClick={() => handleView(product)}
                  className="mt-4 border border-[#3C7C4E] w-full rounded-full h-10 px-2 py-1.5 text-sm font-semibold text-black shadow-sm hover:text-blue-500 hover:bg-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black"
                >
                  View Schedule
                </button>

                <button
                  id="book-schedule-button"
                  type="button"
                  className="mt-4 border border-[#3C7C4E] w-full rounded-full bg-[#111827] h-10 px-2 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-white hover:text-[#3C7C4E] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black"
                >
                  Book your schedule
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServiceProducts;
